$(function () {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/tekoaly-opas-kiitos/"
    };

    $("#aiGuideForm").on("submit", function (event) {
        event.preventDefault();
        if ($('#aiGuideForm')[0].checkValidity() && $('#aiGuideCheckbox').is(':checked')) {
            $("#aiGuideSendBtn").prop("disabled", true);
            $("#aiGuideSendBtn").css("background-color", "#6c757d");

            let email = $("#aiGuideEmail").val();
            let firstName = $("#aiGuideFirstName").val();
            let lastName = $("#aiGuideLastName").val();
            let organization = $("#aiGuideOrganization").val();
            let selectedOccupation = $("input[name='occupation']:checked").val();
            let code = "";
            if ($('#newsletterCheckbox').is(':checked')) {
                code = "newsletter";
            }

            if (selectedOccupation === "Muulla alalla") {
                selectedOccupation = `${selectedOccupation}: ${$("#occupationOther").val()}`;
            }

            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                organizationName: organization,
                additionalInformation: selectedOccupation,
                competitionName: "AI opas",
                uri: "/fi/tekoaly-opas/",
                languageCode: language,
                code: code,
            };

            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function () {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function (err) {
                    console.error(err);
                    $("#aiGuideSendBtn").prop("disabled", false);
                    $("#aiGuideSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        if (!$('#aiGuideForm').length) return;
        const formValid = $('#aiGuideForm')[0].checkValidity();
        const checkboxChecked = $('#aiGuideCheckbox').is(':checked');

        if (formValid && checkboxChecked) {
            $("#aiGuideSendBtn").prop("disabled", false);
            $("#aiGuideSendBtn").css("background-color", "#28a745");
        } else {
            $("#aiGuideSendBtn").prop("disabled", true);
            $("#aiGuideSendBtn").css({
                "background-color": "#6c757d",
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger the button state change on input and checkbox changes
    $('#aiGuideForm input, #aiGuideCheckbox').on('input change', toggleSendButtonState);

    // Initial button state check
    toggleSendButtonState();
});
